window.DELIVERY_SETTINGS = {
  baseLeadTimeDays: 75,
  apiKey: "AIzaSyDiF4cKDfc1GM2Az3h_oWFbZs6Xmlud4CA"
};

(async () => {
  const { apiKey, baseLeadTimeDays } = window.DELIVERY_SETTINGS;

  // 今週の月曜取得
  function getThisWeekMonday(date = new Date()) {
    const d = new Date(date);
    const day = d.getDay();
    // console.log('getThisWeekMonday', 'day', day)
    const diff = day === 0 ? -6 : 1 - day;
    d.setDate(d.getDate() + diff);
    d.setHours(0,0,0,0);
    // console.log('getThisWeekMonday', 'd', d)
    return d;
  }

  // 日付だけで比較
  function isSameOrBeforeDay(a, b) {
    const da = new Date(a.getFullYear(), a.getMonth(), a.getDate());
    const db = new Date(b.getFullYear(), b.getMonth(), b.getDate());
    // console.log('isSameOrBeforeDay', 'a', da)
    // console.log('isSameOrBeforeDay', 'b', db)
    // console.log('isSameOrBeforeDay', 'da.getTime() <= db.getTime()', da.getTime() <= db.getTime())
    return da.getTime() <= db.getTime();
  }

  // 締切日（金曜 or 来週金曜）
  function getCutoffDate(today) {
    const monday = getThisWeekMonday(today);
    // console.log('getCutoffDate', 'monday', monday)
    const friday = new Date(monday);
    // console.log('getCutoffDate', 'friday', friday)
    friday.setDate(friday.getDate() + 4);
    // console.log('getCutoffDate', 'friday.getDate() + 4', friday)
    if ( isSameOrBeforeDay(today, friday) ) {
      // console.log('getCutoffDate', 'isSameOrBeforeDay=true')
      return friday;
    } else {
      // console.log('getCutoffDate', 'isSameOrBeforeDay=false')
      const next = new Date(friday);
      next.setDate(next.getDate() + 7);
      // console.log('getCutoffDate', 'next', next)
      return next;
    }
  }

  // 祝日取得
  async function fetchJapaneseHolidays(startDate, endDate) {
    const calId = 'ja.japanese.official%23holiday%40group.v.calendar.google.com';
    const url = `https://www.googleapis.com/calendar/v3/calendars/${calId}/events`
              + `?key=${apiKey}`
              + `&timeMin=${startDate.toISOString()}`
              + `&timeMax=${endDate.toISOString()}`
              + `&singleEvents=true&orderBy=startTime`;
    const res = await fetch(url);
    const data = await res.json();
    return (data.items||[]).map(ev => ev.start.date);
  }

  // 営業日加算
  function addBusinessDays(startDate, days, holidays) {
    const pad = n => String(n).padStart(2, '0');
    const result = new Date(startDate);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
     // ローカル日付を 'YYYY-MM-DD' 形式で取得
      const ds = [
       result.getFullYear(),
       pad(result.getMonth() + 1),
       pad(result.getDate())
      ].join('-');
      // console.log('addBusinessDays', 'ds', ds)
      const wd = result.getDay();
      // console.log('addBusinessDays', 'wd', wd)
      // console.log('addBusinessDays', '!holidays.includes(ds)', !holidays.includes(ds))
      if (wd !== 0 && wd !== 6 && !holidays.includes(ds)) {
        added++;
        // console.log('addBusinessDays', 'added', added)
      }
    }
    // console.log('addBusinessDays', 'result', result)
    return result;
  }

  // 実行本体
  const today      = new Date();
  const cutoffDate = getCutoffDate(today);

  // 今月1日〜４ヶ月後末日まで祝日取得
  const holidays   = await fetchJapaneseHolidays(
    new Date(today.getFullYear(), today.getMonth(), 1),
    new Date(today.getFullYear(), today.getMonth()+4, 0)
  );

  const deliveryDate = addBusinessDays(cutoffDate, baseLeadTimeDays, holidays);

  // デバッグログ
  console.log('📅 today        =', today.toLocaleDateString());
  console.log('✂︎ cutoffDate   =', cutoffDate.toLocaleDateString());
  console.log('🛠  holidays     =', holidays);
  console.log('🚚 deliveryDate =', deliveryDate.toLocaleDateString());

  // 表示部
  const fmt = d => `${d.getMonth()+1}月${d.getDate()}日`;
  const html = `
    <div style="background:#f8f9fa;padding:1rem;border-left:4px solid #007bff;
                border-radius:8px;">
      <h4 style="margin:0 0 0.5rem;">📦 お届け予定日</h4>
      <p style="margin:0;">
        <strong>${fmt(cutoffDate)}まで</strong>のご注文 →
        <strong style="color:#007bff;">${fmt(deliveryDate)}</strong>までにお届け予定
      </p>
      <p style="font-size:0.85rem;color:#888;">
        ※ハンドメイド商品のため営業日ベースでお時間を頂いております。
      </p>
    </div>`;
  const container = document.getElementById('delivery-info');
  if (container) container.innerHTML = html;
})();

